<div class="upload"
  fxLayout="column"
  fxLayoutAlign="center center"
  fxLayoutGap="15"
  data-qa="file-upload-form"
  (dragover)="onDragOver($event)"
  (drop)="onDrop($event)"
  (dragleave)="onDragLeave($event)"
  [ngClass]="{'dragging': isDragging, 'validation-violation': hasValidationViolations()}">

  <input hidden
    type="file"
    #fileInput
    data-qa="file-input"
    accept="{{allowedFileMimeType}}"
    (change)="onFileChanged()" />

  <div data-qa="file-upload-captions">
    @if (!selectedFile) {
      <span data-qa="file-upload-hint">
        Wählen Sie eine Datei aus oder ziehen Sie die gewünschte Datei in den markierten Bereich.
      </span>
    }

    @if (selectedFile) {
      <span data-qa="file-upload-selected-file">
        <strong>Ausgewählte Datei:</strong> {{selectedFile.name}}
      </span>
    }
  </div>

  <button [matButton]="selectedFile ? 'outlined' : 'filled'"
    data-qa="file-input-button"
    [class.button-warn]="hasValidationViolations()"
    (click)="fileInput.click()">
    @if (!selectedFile && !hasValidationViolations()) {
      <mat-icon data-qa="file-upload-button-icon-upload" fontIcon="queue"></mat-icon>
    }
    @if (selectedFile && !hasValidationViolations()) {
      <mat-icon data-qa="file-upload-button-icon-success" fontIcon="check_circle_outline"></mat-icon>
    }
    @if (hasValidationViolations()) {
      <mat-icon data-qa="file-upload-button-icon-danger" fontIcon="highlight_off"></mat-icon>
    }
    @if (!selectedFile && !hasValidationViolations()) {
      <span data-qa="file-upload-button-message-upload" >{{allowedFileTypeName}} Datei auswählen</span>
    }
    @if (selectedFile && !hasValidationViolations()) {
      <span data-qa="file-upload-button-message-upload-replace">Eine andere {{allowedFileTypeName}} Datei auswählen</span>
    }
    @if (isInvalidFileFormat) {
      <span data-qa="file-upload-button-message-warning-file-format">Ungültiges Dateiformat</span>
    }
    @if (areMultipleFiles) {
      <span data-qa="file-upload-button-message-warning-multiple-files">Dateien können nur einzeln hochgeladen werden</span>
    }
  </button>

</div>
